export const tableNames = {
  Creditorsgroupsub: "Creditor subgroup(s)",
};

export const formatTableName = (raw: string) => (tableNames[raw] ? tableNames[raw] : raw);
